export function send_event(category, action, label) {
    if (typeof window == 'undefined') {
        console.error('No window object')
        return false
    }
    if (!window.hasOwnProperty('dataLayer')) {
        console.error('No dataLayer')
        return false
    }
    var data = {
        event:"simonsays-event",
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    }
    window.dataLayer.push(data)
}
